import { createFileRoute, Navigate } from '@tanstack/react-router'
import { MagicLinkLoginPage } from 'pages/magic-link-login/MagicLinkLoginPage'
import { useIsLoggedIn } from 'hooks/useIsLoggedIn'

export const Route = createFileRoute('/magiclink')({
  component: MagicLinkRoute,
})

function MagicLinkRoute() {
  const isLoggedIn = useIsLoggedIn()

  if (isLoggedIn) {
    return <Navigate to="/app" />
  }

  return <MagicLinkLoginPage />
}
